function Validacija () {
}

Validacija.prototype.HisnaStevilkaValidation = function (hs) {
  return new RegExp('^[0-9]{1,5}[aA-zZ]{0,2}$').test(hs)
}

Validacija.prototype.ImeValidation = function (ime) {
  if (ime.length !== 0) {
    ime.trim()
  }
  return new RegExp('^[\\wČčŠšŽž\\s]{1,80}').test(ime)
}

Validacija.prototype.TelefonskaStevilkaValidation = function (telefonStevilka) {
  return new RegExp(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)$/).test(telefonStevilka)
}

Validacija.prototype.PreverjanjeNaslova = function (naslov) {
  return new RegExp(/^([^,]+)(?:[,]+)[\s]*(?:([^,\d]*),)?[\s]*([\d]{4})/i).test(naslov) || naslov.trim() === ''
}

Validacija.prototype.PreverjanjeGeslaEmail = function (geslo) {
  return new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{7,32})').test(geslo)
}

Validacija.prototype.EmailValid = function (email) {
  return new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$').test(email)
}

Validacija.prototype.JeT2Domena = function (email) {
  return new RegExp('\\b(t-2.net|t-2.si)\\b').test(email)
}

export default Validacija



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Validacija.js